import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

// Connects to data-controller="lightbox"
export default class extends Controller {
  static get targets() {
    return ["link", "caption"]
  }

  connect() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: this.linkTarget,

      // setup PhotoSwipe Core dynamic import
      pswpModule: () => import('photoswipe')
    });

    const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
      type: 'auto',
      captionContent: (slide) => {
          return this.captionTarget.innerHTML;
      }
    });
    

    lightbox.init();
  }
}